import { getActivities } from '@/utils/facilitiesBooking'
import { ActionTree, GetterTree, MutationTree } from 'vuex'
import { RootState } from '..'
import { SET_ACTIVITIES } from '../types'

export interface IHotel {
  name: string;
  room: string;
  room_number?: string;
  booking_number?: string;
  ref_number?: string;
  company_name?: string;
  others?: string;
}

export interface IBooking {
  name: string;
  room?: string;
  roomInt?: number;
  hotel?: IHotel;
  isExceed?: boolean;
  phone?: string;
  status: number;
  pax: number;
  email: string;
  date: string | Date;
  createdAt: Date;
  facility: string;
  facilityDetail?: IFacility;
  queueBookingCallCount?: number;
  slot?: string;
  slotList?: string[];
  bookingType?: string;
  slotsStart?: string;
  slotsEnd?: string;
  slotTimes?: string;
  customer?: string;
  merchant: string;
  holdAt?: Date;
  updatedAt?: Date;
  channel?: IHotel;
}

export interface ICapacity {
  _id?: string;
  capacity: number;
  affectedDate: Date;
  createdDate: Date;
}

export interface IFacilitySlot {
  _id?: string;
  key?: string;
  start: string;
  day?: number;
  end: string;
  name?: string;
  capacity?: ICapacity[];
  affectedDate?: Date;
  capacitySlot?: number;
  isActive?: boolean;
  bookings?: IBooking[];
}

export interface IFacility {
  _id?: string;
  disableActivity?: boolean;
  bookingType?: string;
  category?: string;
  subCategory?: string;
  name: string;
  desc: string;
  bgColor: string;
  merchant: string;
  color?: string;
  textColor?: string;
  restrictedDateRange?: number;
  maxPaxPerBooking?: number;
  policy: {
    title?: string;
    info?: string;
  };
  settings: {
    currentCapacity?: number;
    changedCapacity?: boolean;
    slotCapacity: number;
    slots: IFacilitySlot[];
    slotType?: 'basic' | 'advanced';
    capacities: ICapacity[];
    enabledBookingDays?: number[];
  };
}

export interface FacilityState {
   activities: IFacility[];
}

const state: FacilityState = {
  activities: []
}

const getters: GetterTree<FacilityState, RootState> = {
    activities: (state) => state.activities,
}

const mutations: MutationTree<FacilityState> = {
  [SET_ACTIVITIES](state, activities: IFacility[]) {
    state.activities = activities
  },
}

const actions: ActionTree<FacilityState, RootState> = {
  async loadActivities({ commit }) {
    const activities = await getActivities()
    return commit(SET_ACTIVITIES, activities)
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
